import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { ownerFavoriteService } from '../../api/manpro/ownerFavoriteService';

export const useVendorFavorite = () => {
  const queryClient = useQueryClient();

  const { data: savedVendors = [], isLoading, isError } = useQuery({
    queryKey: ['savedVendors'],
    queryFn: () => ownerFavoriteService.getFavoriteProviders(),
  });

  const addVendorMutation = useMutation({
    mutationFn: ownerFavoriteService.addFavoriteProvider,
    onMutate: async (data: { providerId: string; servicemanId?: string }) => {
      await queryClient.cancelQueries({ queryKey: ['savedVendors'] });
      const previousVendors = queryClient.getQueryData(['savedVendors']);
      
      queryClient.setQueryData(['savedVendors'], (old: any) => {
        if (!old) return [{ provider_id: data.providerId, serviceman_id: data.servicemanId }];
        return [...old, { provider_id: data.providerId, serviceman_id: data.servicemanId }];
      });
      
      return { previousVendors };
    },
    onSuccess: () => {
      toast.success('Vendor berhasil ditambahkan ke favorit.');
      queryClient.invalidateQueries({ queryKey: ['savedVendors'] });
    },
    onError: (err, newTodo, context: any) => {
      queryClient.setQueryData(['savedVendors'], context?.previousVendors);
      toast.error('Gagal menambahkan vendor ke favorit.');
    },
  });

  const removeVendorMutation = useMutation({
    mutationFn: ownerFavoriteService.removeFavoriteProvider,
    onMutate: async (data: { providerId: string; servicemanId?: string }) => {
      await queryClient.cancelQueries({ queryKey: ['savedVendors'] });
      const previousVendors = queryClient.getQueryData(['savedVendors']);
      
      queryClient.setQueryData(['savedVendors'], (old: any) => 
        old?.filter((fav: any) => !(fav.provider_id === data.providerId && fav.serviceman_id === data.servicemanId))
      );
      
      return { previousVendors };
    },
    onSuccess: () => {
      toast.success('Vendor dihapus dari daftar tersimpan.');
    },
    onError: (err, variables, context: any) => {
      queryClient.setQueryData(['savedVendors'], context?.previousVendors);
      toast.error('Gagal menghapus vendor.');
    },
  });

  const isVendorSaved = (providerId: string, servicemanId?: string) => {
    return savedVendors.some((v: any) => v.provider_id === providerId && v.serviceman_id == servicemanId);
  };

  const toggleVendorFavorite = (providerId: string, servicemanId?: string) => {
    if (isVendorSaved(providerId, servicemanId)) {
      removeVendorMutation.mutate({ providerId, servicemanId });
    } else {
      addVendorMutation.mutate({ providerId, servicemanId });
    }
  };

  return {
    savedVendors,
    isLoading,
    isError,
    addVendor: addVendorMutation.mutate,
    removeVendor: removeVendorMutation.mutate,
    isAdding: addVendorMutation.isPending,
    isRemoving: removeVendorMutation.isPending,
    isVendorSaved,
    toggleVendorFavorite,
  };
};
